import { createGlobalStyle } from 'styled-components';

import Reset from './Reset';
import Fontface from './typhography/Fontface';
import Typhography from './typhography/Typhography';
import { scrollbarStyle } from './variants/scrollbar';

const GlobalStyle = createGlobalStyle`
  ${Reset}
  ${Fontface}
  ${Typhography}
  
  body,
  html {
    cursor: var(--defaultCursorURL), auto;
  }


  body {
    position: relative;
    min-height: 100vh;
    padding-bottom: env(safe-area-inset-bottom);
    
    // 배경이미지 부분
    &::before {
      content: "";
      display: block;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -2;
      /* 이미지 레이어(위) + 그라디언트/단색 레이어(아래) */
      background: var(--backgroundImgURL, none) center/cover no-repeat, 
                  var(--backgroundColor) center/cover no-repeat;
    }

    // 페이드 전환용 오버레이 레이어
    // --backgroundColorNext: 배경색 전환 시 새 색상을 오버레이에 먼저 표시
    // 설정되지 않았을 때는 --backgroundColor 폴백으로 현재 색상을 그대로 유지
    &::after {
      content: "";
      display: block;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      background: var(--backgroundImgURLNext, none) center/cover no-repeat,
                  var(--backgroundColorNext, var(--backgroundColor)) center/cover no-repeat;
      opacity: var(--bgFadeActive, 0);
      transition: opacity 0.4s ease-out;
      pointer-events: none;
    }

  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  #portalModal {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index:0;
  }

  input {
    color: var(--textColor);
    font-family: var(--defaultFontFamily);
    font-size: var(--textSize);

    &::placeholder {
      color: var(--subTextColor);
      font-size: var(--textSize);
    }
  }
  // 자동입력 커스텀
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid var(--primaryColor);
    box-shadow: 0 0 0 1000px var(--backgroundColor) inset;
    border-radius: var(--cardBorderRadius);
    -webkit-text-fill-color: var(--textColor);
  }

  button {
    font-family: var(--defaultFontFamily);
    font-size: 14px;
    color: var(--buttonTextColor);
  }

  ::selection {
    background-color: var(--buttonBackgroundColor);
    color: var(--buttonTextColor);
  }

  :root {

  }

  textarea {
    overflow-y: auto; 

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: var(--cardBackgroundColor);
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--primaryColor);
      border-radius: var(--buttonBorderRadius);
      border-radius: 5px !important;
      background-clip: content-box !important;
    } 
  }


  html {
    /* 폰트 설정 */
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  -ms-overflow-style: none !important;

  /* 스크롤바 설정 */
  /* scrollbar-width: none !important;
  -moz-scrollbar: none !important; */
${scrollbarStyle}
  /* 이미지 설정 */ 
  }

`;

export default GlobalStyle;
